import { render, staticRenderFns } from "./BinnacleHistory.vue?vue&type=template&id=568735ed"
import script from "./BinnacleHistory.vue?vue&type=script&lang=js"
export * from "./BinnacleHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports